export const orderDeliveryTypes = [
  {
    label: "Pick up",
    value: 20,
  },
  {
    label: "Dine-in",
    value: 10,
  },
];

export const orderPaymentStatusList = [
  {
    label: "Not Paid",
    value: 0,
    colors: "bg-red-500 text-red-50",
    colorCode: "green-500",
  },
  {
    label: "Paid",
    value: 20,
    colors: "bg-green-500 text-green-50",
    colorCode: "green-500",
  },
];

export const orderStatusList = [
  {
    label: "Pending",
    value: 0,
    colors: "bg-yellow-500 text-yellow-50",
    colorCode: "yellow-500",
  },
  {
    label: "Accepted",
    value: 10,
    colors: "bg-blue-100 text-blue-500",
    colorCode: "blue-500",
  },
  {
    label: "Ready",
    value: 20,
    colors: "bg-purple-100 text-purple-500",
    colorCode: "blue-500",
  },
  {
    label: "Rejected",
    value: 30,
    colors: "bg-slate-100 text-slate-500",
    colorCode: "slate-500",
  },
  {
    label: "Completed",
    value: 100,
    colors: "bg-green-500 text-green-50",
    colorCode: "green-500",
  },
];

export const dateFormat = "YYYY-MM-DDTHH:mm:ss";
